var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"justify-center bgGrey"},[_c('span',{staticClass:"font-weight-bold title text-caption"},[_vm._v("Legenda:")])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }